import React from 'react';
import elegir_img from "../images/elegir_b-01.svg";
import confirmar_img from "../images/confirmar respuestas_b-01.svg";
import datos_cedula_img from "../images/preguntas_datos_cedula.svg";
import seleccionar_distrito_img from "../images/distrito_b-01.svg";
import preguntas_img from "../images/preguntas_dep_voto.svg";

const RunSerialQuestionsSelect = (props) => {
        return(
            <div className="row mb-4 justify-content-center">
                <div className="col-12 col-lg-2 text-center">
                    <p className="como-title mt-4">1. Seleccionar</p>
                    <p className="font-italic h5 vp-75">Seleccione su {props.district_text}</p>
                    <img src={seleccionar_distrito_img} className="img-max-300 mt-5" alt="Cómo"/>
                </div>
                <div className="col-12 col-lg-2 text-center border-left">
                    <p className="como-title mt-4">2. Elegir</p>
                    <p className="font-italic h5 vp-75">Marque sus preferencias y cierre el voto</p>
                    <img src={elegir_img} className="img-max-300 mt-5" alt="Cómo"/>
                </div>
                <div className="col-12 col-lg-2 text-center border-left">
                    <p className="como-title mt-4">3. Confirmar</p>
                    <p className="font-italic h5 vp-75">Confirme sus respuestas</p>
                    <img src={confirmar_img} className="img-max-300 mt-5" alt="Confirmar"/>
                </div>
                <div className="col-12 col-lg-2 text-center border-left">
                    <p className="como-title mt-4">4. Votar</p>
                    <p className="font-italic h5 vp-75">Ingrese su rut y número de serie o número de documento para obtener desafío</p>
                    <img src={datos_cedula_img} className="img-max-300 mt-5" alt="Votar"/>
                </div>
                <div className="col-12 col-lg-2 text-center border-left">
                    <p className="como-title mt-4">5. Validar</p>
                    <p className="font-italic h5 vp-75">Deposite el voto respondiendo correctamente las 4 preguntas personales</p>
                    <img src={preguntas_img} className="img-max-300 mt-5" alt="Validación"/>
                </div>
            </div>
        )
    }
export default RunSerialQuestionsSelect;